import { ContactBlock } from './ContactBlock';
import { LegacyContactBlock } from './LegacyContactBlock/LegacyContactBlock';

export const determineContactBlock = () => {
  const isNZ = window?.Jbhifi?.storeLocation === 'NZ';

  return isNZ ? LegacyContactBlock : ContactBlock;
};
